module.exports = __webpack_public_path__ + "static/img/modeler-harmonizer.99802d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/modeler-harmonizer.jpg
// module id = bGGM
// module chunks = 12